import { render, staticRenderFns } from "./Cobertura.vue?vue&type=template&id=3c398202&"
import script from "./Cobertura.vue?vue&type=script&lang=js&"
export * from "./Cobertura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports